import { Avatar, Label, Button, makeStyles } from '@fluentui/react-components';
import type { IUserInfo } from '../../../interfaces';


export interface IPopoverContentProps {
    onLogout(): void;
    userData?: IUserInfo;
    imageUrl: string;
}

const useStyles = makeStyles({
    container: {
        maxWidth: '600px',
        marginLeft: '0 auto',
        marginRight: '0 auto',
        marginTop: '0 auto',
        marginBottom: '0 auto',
    },
    logoutButton: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px'
    },
    profileArea: {
        display: 'flex',
        alignItems: 'center'
    },
    userName: {
        marginLeft: '20px'
    },
    profilePicture: {
        width: '90px',
        height: '90px'
    }
});


const PopoverContent = (props: IPopoverContentProps) => {
    const { userData, onLogout, imageUrl } = props;
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <div className={styles.logoutButton}>
                <div></div>
                <Button appearance='transparent' onClick={() => onLogout()}>Sign-out</Button>
            </div>
            <div className={styles.profileArea}>
                <Avatar
                    size={72} className={styles.profilePicture}
                    shape='circular'
                    name={userData?.displayName}
                    image={{ src: imageUrl }}
                />
                <div className={styles.userName}>
                    <div>
                        <Label weight='semibold'>{userData?.displayName}</Label>
                    </div>
                    <div>
                        <Label>{userData?.userPrincipalName}</Label>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopoverContent;
